import React from 'react'

export type ButtonProps = {
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void; // to handle onClick functions
    children?: React.ReactNode; // make the component able to receive children elements
    disabled?: boolean
};

const Button = ({
    onClick,
    children,
    disabled
  }: ButtonProps) => {
  return (
    <button 
        onClick = {onClick} 
        disabled = {disabled}
        className='text-white outline-none bg-main-blue rounded-[34px] text-sm px-10 py-3 z-20 disabled:bg-light-blue'>
        {children}
    </button>
  )
}

export default Button